import { render, staticRenderFns } from "./TabsAccountManagement.vue?vue&type=template&id=15ff3728&scoped=true&"
import script from "./TabsAccountManagement.vue?vue&type=script&lang=js&"
export * from "./TabsAccountManagement.vue?vue&type=script&lang=js&"
import style0 from "./TabsAccountManagement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabsAccountManagement.vue?vue&type=style&index=1&id=15ff3728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ff3728",
  null
  
)

export default component.exports